import type { NavigationListItemProps } from "@bonusx-global/bx-design-system";
import {
  BoxDuotone,
  BoxOutlined,
  EuroCircleDuotone,
  EuroCircleOutlined,
  FileTextEditDuotone,
  FileTextEditOutlined,
  FileWandDuotone,
  FileWandOutlined,
  LogOutDuotone,
  LogOutOutlined,
  MoreHorizontalDuotone,
  MoreHorizontalOutlined,
  SettingsDuotone,
  SettingsOutlined,
  UserCircleDuotone,
  UserCircleOutlined,
} from "@bonusx-global/bx-icons";
import {
  EXTERNAL_PATH_COLLECTION,
  LOGOUT_ROUTE,
  PROFILE_PATH,
  REQUESTED_SERVICES_PATH,
  SERVICES_PATH,
  SETTINGS_PATH,
  PRICING_PAGE_PATH,
} from "../../../constants/env";

export const citizenRoutes: NavigationListItemProps[] = [
  {
    path: PROFILE_PATH,
    label: "Profilo",
    icon: <UserCircleOutlined />,
    iconSelected: <UserCircleDuotone />,
  },
  {
    path: SERVICES_PATH,
    label: "Bonus",
    icon: <EuroCircleOutlined />,
    iconSelected: <EuroCircleDuotone />,
  },
  {
    path: REQUESTED_SERVICES_PATH,
    label: "Pratiche",
    icon: <FileTextEditOutlined />,
    iconSelected: <FileTextEditDuotone />,
  },
  {
    path: PRICING_PAGE_PATH,
    label: "Upgrade",
    icon: <FileWandOutlined />,
    iconSelected: <FileWandDuotone />,
  },
  {
    label: "Altro",
    icon: <MoreHorizontalOutlined />,
    iconSelected: <MoreHorizontalDuotone />,
    disabled: true,
    isSectionDivider: true,
  },
  {
    path: SETTINGS_PATH,
    label: "Impostazioni",
    icon: <SettingsOutlined />,
    iconSelected: <SettingsDuotone />,
  },
  {
    icon: <BoxOutlined />,
    label: "Scartoffie",
    subpaths: [
      { label: "Termini di utilizzo", path: EXTERNAL_PATH_COLLECTION.get("terms_of_use") },
      { label: "Condizioni Generali di Servizio", path: EXTERNAL_PATH_COLLECTION.get("general_conditions_of_service") },
      { label: "Privacy Policy", path: EXTERNAL_PATH_COLLECTION.get("privacy_policy") },
      { label: "Cookies Policy", path: EXTERNAL_PATH_COLLECTION.get("cookies_policy") },
    ],
    iconSelected: <BoxDuotone />,
  },
  {
    path: LOGOUT_ROUTE,
    label: "Logout",
    icon: <LogOutOutlined />,
    iconSelected: <LogOutDuotone />,
  },
];
